import { render } from "./DeleteOffice.vue?vue&type=template&id=45cd6adc"
import script from "./DeleteOffice.vue?vue&type=script&lang=js"
export * from "./DeleteOffice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__